export const CHATBOT_WIDGET_API_HOST = 'https://realairschedule-live-337716927225.us-east4.run.app';

export const readChatbotSettingsResponse = async (response) => {
  let data;
  try {
    data = await response.json();
  } catch {
    const endpoint = response.url ? new URL(response.url).origin + new URL(response.url).pathname : '/chatbot/settings';
    throw new Error(`Chatbot settings API returned a non-JSON response (HTTP ${response.status}) from ${endpoint}. Check the API deployment and route; it may be returning an HTML error or redirect page.`);
  }
  if (!response.ok) throw new Error(data?.error || `Chatbot settings request failed (HTTP ${response.status}).`);
  return data;
};

export const createChatbotDraft = (settings) => ({
  website: settings?.website ?? settings?.publicInformation?.website ?? '',
  instructions: settings?.instructions ?? '',
  welcomeMessage: settings?.publicInformation?.welcomeMessage ?? '',
  enabled: settings?.enabled ?? true,
  bookingEnabled: settings?.bookingEnabled ?? false
});

export const buildChatbotSettingsPayload = (draft, saved = null) => {
  const website = String(draft.website || '').trim();
  try {
    const url = new URL(website);
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) throw new Error('Invalid website');
  } catch {
    throw new Error('Enter a valid HTTP or HTTPS school website without embedded credentials.');
  }
  const instructions = String(draft.instructions || '').trim();
  if (!instructions) throw new Error('Enter instructions describing what the chatbot should offer and how it should respond.');
  const welcomeMessage = String(draft.welcomeMessage || '').trim();
  if (welcomeMessage.length > 1000) throw new Error('Welcome message must be 1,000 characters or fewer.');
  const payload = { enabled: !!draft.enabled, bookingEnabled: !!draft.bookingEnabled, instructions };
  if (!saved || website !== saved.website) payload.website = website;
  const savedWelcomeMessage = String(saved?.publicInformation?.welcomeMessage || '').trim();
  if ((saved && welcomeMessage !== savedWelcomeMessage) || (!saved && welcomeMessage)) {
    payload.publicInformation = { welcomeMessage };
  }
  return payload;
};

export const buildChatbotEmbed = (widgetKey, locationId = '') => {
  if (!widgetKey) return '';
  const escapeAttribute = value => String(value).replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
  const locationAttribute = locationId !== '' && locationId != null ? `\n  data-location-id="${escapeAttribute(locationId)}"` : '';
  return `<script\n  defer\n  src="${CHATBOT_WIDGET_API_HOST}/chatbot/widget.js"\n  data-widget-key="${escapeAttribute(widgetKey)}"${locationAttribute}>\n</script>`;
};